import { CustomHandle } from '@/adapter/blockAdapter';
import { useSelected } from '@/hooks/useSelected';
import { Box, useTheme } from '@mui/material';
import React, { FC } from 'react';
import { Handle, Position } from '@xyflow/react';

type CustomHandleViewProps = {
  position: 'right' | 'left';
  handle: CustomHandle | undefined;
};

const CustomHandleView: FC<CustomHandleViewProps> = ({ position, handle }) => {
  const theme = useTheme();
  const { setSelectedEdge } = useSelected();

  const getHandleStyle = (position: 'left' | 'right', psuedo?: boolean): React.CSSProperties => {
    const marginSpacing = 1.05;
    const clipPath =
      position === 'right'
        ? 'polygon(0% 0%, 50% 0%, 50% 100%, 0% 100%)'
        : 'polygon(50% 0%, 100% 0%, 100% 100%, 50% 100%)';

    return psuedo
      ? {
          position: 'absolute',
          height: theme.spacing(2),
          width: theme.spacing(2),
          borderRadius: '50%',
          backgroundColor: theme.palette.common.black,
          clipPath: clipPath,
          border: 'none',
          opacity: 0.5,
          transform: 'inherit',
          top: 0,
          ...(position === 'right'
            ? { left: theme.spacing(marginSpacing) }
            : { left: theme.spacing(-marginSpacing * 2) })
        }
      : {
          position: 'relative',
          transform: 'inherit',
          height: theme.spacing(2),
          width: theme.spacing(1),
          top: 0,
          borderRadius: '0',
          borderColor: 'black',
          opacity: 0,
          ...(position === 'right' ? { left: theme.spacing(marginSpacing) } : { left: theme.spacing(-marginSpacing) })
        };
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <div style={getHandleStyle(position, true)} />
      {handle && (
        <Handle
          id={handle.id}
          type={handle.type}
          position={position === 'right' ? Position.Right : Position.Left}
          onClick={(e) => {
            e.stopPropagation();
            setSelectedEdge({ id: handle.id, type: handle.type });
          }}
          style={getHandleStyle(position)}
        />
      )}
    </Box>
  );
};

export default CustomHandleView;
